import  React , {Component as ReactComponent} from "react";

export const layout = (PageLayout: any, args: any = {}) => {
    return (PageComponent: any): any => {
        return class extends ReactComponent {
            private component: any =  React.createRef();

            constructor(props: Map<any, any>) {
                super(props);
                this.changeLang = this.changeLang.bind(this);
            }

            changeLang(){
                if(this.component){
                    this.component.getData();
                }
            }

            render() {
                let data: any = null;
                if (args instanceof Function) {
                    data = args(this);
                } else {
                    data = args;
                }

                return (
                    <PageLayout changeLang={this.changeLang} args={data}>
                        <PageComponent onRef={(ref:any)=>{this.component = ref}} {...this.props} />
                    </PageLayout>
                );
            }
        }
    };
};